import { render } from "./SmsTemplates.vue?vue&type=template&id=803022ac&scoped=true"
import script from "./SmsTemplates.vue?vue&type=script&lang=js"
export * from "./SmsTemplates.vue?vue&type=script&lang=js"

import "./SmsTemplates.vue?vue&type=style&index=0&id=803022ac&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-803022ac"]])

export default __exports__